import { useState } from "react";
import CreateRoleForm from "./CreateRoleForm";
import ManageRolesTab from "./ManageRolesTab";

const TABS = [
  { value: "create", label: "Create Role" },
  { value: "manage", label: "Manage Roles" },
] as const;

type TabValue = (typeof TABS)[number]["value"];

const RolesAndPermissionsTab = () => {
  const [activeTab, setActiveTab] = useState<TabValue>("create");

  return (
    <div className="flex flex-col gap-5">
      {/* Sub-tab pill switcher */}
      <div className="scrollbar-none overflow-x-auto">
        <div className="flex w-fit gap-1 rounded-xl border border-gray-200 bg-gray-50 p-1">
          {TABS.map((t) => (
            <button
              key={t.value}
              onClick={() => setActiveTab(t.value)}
              className={
                activeTab === t.value
                  ? "whitespace-nowrap rounded-lg bg-white px-4 py-1.5 text-sm font-semibold text-gray-900 shadow-sm"
                  : "whitespace-nowrap rounded-lg px-4 py-1.5 text-sm font-medium text-gray-500 hover:text-gray-700"
              }
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === "create" ? <CreateRoleForm /> : <ManageRolesTab />}
    </div>
  );
};

export default RolesAndPermissionsTab;
